<template>
  <div class="relative w-full">
    <DropDown
      :height="height"
      :button-label="label"
      :menu-items="items"
      radius="lg"
      :unique-identifier="uniqueIdentifier"
      @menu-item-selected="$emit('item-selected', $event)"
    />
  </div>
</template>

<script>
import DropDown from "@/components/form-components/DropDown.vue";

export default {
  name: "FilterDropdown",
  components: { DropDown },
  props: {
    items: Array,
    label: String,
    uniqueIdentifier: String,
    height: String,
  },
};
</script>
